/* Nombres de producto en PDP, cards, búsqueda y carrito, incluso tras renders de Dawn. */
(() => {
  const selector = [
    '.product__title h1',
    'h2.product__title',
    '.card__heading a[href]',
    '#predictive-search-results-products-list .predictive-search__item-heading',
    '.cart-item__name',
    '.cart-order-summary .cart-item-title',
    '.cart-notification-product__name',
    'a[class*="ai-category-sale__name-"]',
    'h4[class*="__product-title"] a',
    '.ai-video-collection__title',
    '.vc-name',
    '.creditex-drawer-suggestion__title'
  ].join(', ');

  const preserve = new Set([
    'MBO', 'CF', 'PET', 'UV', 'UPF', 'PVP', 'SKU',
    'DNI', 'RUC', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'
  ]);

  function titleCase(value) {
    return value.replace(/[\p{L}\p{N}]+/gu, word => {
      const upper = word.toLocaleUpperCase('es');
      if (preserve.has(upper) || (/\d/.test(word) && /\p{L}/u.test(word))) return upper;
      const lower = word.toLocaleLowerCase('es');
      return lower.charAt(0).toLocaleUpperCase('es') + lower.slice(1);
    });
  }

  function format(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const value = titleCase(node.nodeValue);
      if (value !== node.nodeValue) node.nodeValue = value;
    }
  }

  function scan(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const title = node.parentElement?.closest(selector);
      if (title) format(title);
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches(selector)) format(node);
    node.querySelectorAll(selector).forEach(format);
  }

  function start() {
    if (!document.body) return;
    scan(document.body);
    const pending = new Set();
    let scheduled = false;
    const flush = () => {
      scheduled = false;
      pending.forEach(scan);
      pending.clear();
    };
    new MutationObserver(changes => {
      for (const change of changes) {
        if (change.type === 'characterData') pending.add(change.target);
        else {
          change.addedNodes.forEach(node => pending.add(node));
          if (change.target.closest?.(selector)) pending.add(change.target);
        }
      }
      if (!scheduled && pending.size) {
        scheduled = true;
        queueMicrotask(flush);
      }
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
